export const supportedLanguagePaths = ["de", "en", "es", "fr", "it", "ja", "ko", "pt", "ru", "zh"];

export default {
  //INDEX: "/:lang([a-z]{2})?",
  INDEX: "/:lang(" + supportedLanguagePaths.join("|") + ")?",
  UPLOAD: "/upload",
  MASK_EDITOR: "/maskeditor",
  PROCESSING: "/processing/:hash?",
  RESULT: "/result",
  ERROR: "/error",
};
